import { useState } from 'react'
import { Link } from 'react-router'
import { useSessione } from '../servizi/sessione.tsx'
import { sistemaTelefono } from '../servizi/app-nativa.ts'
import { indirizzoIstruzioni, rimanda, rimandato, useInvitoAppServe } from '../servizi/app-telefono.ts'
import { BottoneIcona } from './base.tsx'
import { DisegnoQr } from './DisegnoQr.tsx'
import { IconaChiudi, IconaTelefono } from './Icone.tsx'

/**
 * Banner dell'app per il telefono sul cruscotto (richiesta di Davide del 2/11/2026).
 *
 * - Dal computer: il codice QR che apre le istruzioni sul telefono, con le due strade in breve.
 * - Dal telefono Android: «Scarica l'app» scarica subito l'APK, «Istruzioni» porta al riquadro del profilo.
 * - Dall'iPhone: i tre tocchi in Safari per mettere il gestionale nella schermata Home.
 *
 * Non compare dove l'app non serve (dentro l'app, dalla schermata Home, con un telefono gia' connesso,
 * impersonando: servizi/app-telefono.ts). La crocetta lo nasconde dal cruscotto per trenta giorni.
 */
export function BannerAppTelefono() {
  const { io } = useSessione()
  const [chiuso, setChiuso] = useState(false)
  const serve = useInvitoAppServe(io)
  if (!io || !serve || chiuso || rimandato('cruscotto', io.id)) return null
  const s = sistemaTelefono()
  const chiudi = () => { rimanda('cruscotto', io.id, 30); setChiuso(true) }

  return (
    <section className="banner-app" aria-labelledby="banner-app-titolo">
      <span className="banner-app-icona" aria-hidden="true"><IconaTelefono /></span>
      <div className="banner-app-testo">
        <h2 id="banner-app-titolo">
          {s === 'android' ? 'Installa l’app CIDIS' : s === 'iphone' ? 'Il gestionale nella schermata Home'
            : 'Il gestionale anche sul telefono'}
        </h2>
        {s === 'android' && (
          <>
            <p>Resta connessa per 30 giorni, si sblocca con l’impronta o il volto e ti avvisa delle novità.</p>
            <div className="banner-app-azioni">
              <a className="bottone bottone-primario" href="/app/cidis.apk" download="CIDIS.apk">Scarica l’app</a>
              <Link className="bottone bottone-secondario" to="/profilo#app-telefono">Istruzioni</Link>
            </div>
          </>
        )}
        {s === 'iphone' && (
          <>
            <ol className="banner-app-passi">
              <li>In Safari tocca <strong>Condividi</strong>, il quadrato con la freccia verso l’alto.</li>
              <li>Scegli <strong>Aggiungi alla schermata Home</strong>, poi <strong>Aggiungi</strong>.</li>
              <li>Apri CIDIS dalla schermata Home, entra e tocca <strong>Attiva Face ID</strong>.</li>
            </ol>
            <div className="banner-app-azioni">
              <Link className="bottone bottone-secondario" to="/profilo#app-telefono">Istruzioni complete</Link>
            </div>
          </>
        )}
        {s === 'altro' && (
          <>
            <p>
              Inquadra il codice con la fotocamera del telefono: si aprono le istruzioni. Su <strong>Android</strong> installi
              l’app CIDIS, sull’<strong>iPhone</strong> aggiungi il gestionale alla schermata Home. Resta connesso per 30
              giorni e si sblocca con l’impronta, il volto o Face ID.
            </p>
            <div className="banner-app-azioni">
              <Link to="/profilo#app-telefono">Istruzioni passo passo</Link>
            </div>
          </>
        )}
      </div>
      {s === 'altro' && (
        <DisegnoQr testo={indirizzoIstruzioni(io)}
                   etichetta="Codice QR che apre sul telefono le istruzioni per installare l’app" />
      )}
      <span className="banner-app-chiudi">
        <BottoneIcona icona={<IconaChiudi />} etichetta="Nascondi dal cruscotto per trenta giorni" onClick={chiudi} />
      </span>
    </section>
  )
}
